// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles_hero__iF5aY","hero__wrapper":"styles_hero__wrapper__zqZo_","hero__title":"styles_hero__title__MU465","hero__subtitle":"styles_hero__subtitle__1DfjE"};